import { useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Button,
  Select,
  MenuItem,
  Switch,
} from "../../../../components";
import { PermisoesHelper } from "../../../../helpers";
import { SessionService } from "../../../../services";
import {
  CamposPersonalizadosAtivosDialog,
  StatusPersonalizadoOsDialog,
} from "../dialogComponents";
import "../../configuracoes.style.css";
import { DesktopTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import ConfiguracoesOrdemServicosDialog from "../dialogComponents/configuracoes-ordem-servico.component";

const ConfiguracaoServicosTab = ({
  configuracao,
  onChange,
  onChangeSwitch,
}) => {
  const [openDialogPrecificao, setOpenDialogPrecificao] = useState(false);
  const [openDialogConfiguracao, setOpenDialogConfiguracao] = useState(false);
  const [openDialogStatusPersonalizados, setOpenDialogStatusPersonalizados] =
    useState(false);
  const [abrirPersonalizado, setAbrirPersonalizado] = useState(false);
  const [horaPersonalizada, setHoraPersonalizada] = useState(null);
  const [antecedenciaPersonalizada, setAntecedenciaPersonalizada] =
    useState(null);

  const permissoesHelper = new PermisoesHelper();
  const sessionService = new SessionService();
  const dadosEmpresa = sessionService.getEmpresa();

  useEffect(() => {
    if (
      configuracao.lembreteAntecedenciaServico &&
      ![15, 30, 60].includes(configuracao.lembreteAntecedenciaServico)
    ) {
      const minutos = configuracao.lembreteAntecedenciaServico;
      const horas = Math.floor(minutos / 60);
      const restoMinutos = minutos % 60;
      setAntecedenciaPersonalizada(minutos);
      setHoraPersonalizada(new Date(0, 0, 0, horas, restoMinutos));
    }
  }, []);

  const aplicarAntecedencia = (value) => {
    const minutos = value.getHours() * 60 + value.getMinutes();
    setAntecedenciaPersonalizada(minutos);
    onChange({
      target: {
        name: "lembreteAntecedenciaServico",
        value: minutos,
      },
    });
    setAbrirPersonalizado(false);
  };

  const formatarAntecedencia = (minutos) => {
    if (minutos < 60) {
      return `${minutos} minutos`;
    }
    const horas = Math.floor(minutos / 60);
    const restoMinutos = minutos % 60;
    if (restoMinutos === 0) {
      return `${horas} ${horas === 1 ? "Hora" : "Horas"}`;
    }
    return `${horas}h ${restoMinutos}min`;
  };

  return (
    <>
      <Card className="p-2">
        <CardContent>
          <Grid container spacing={2} className="config-card" rowSpacing={5}>
            {dadosEmpresa?.moduloServico ? (
              <>
                <Grid item xs={8}>
                  SER001 - Ativos de serviço.
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => setOpenDialogPrecificao(true)}
                  >
                    <b>CADASTRO DE ATIVOS</b>
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  SER002 - Avisar o cliente referente ao agendamento com
                  antecedência de.
                </Grid>
                <Grid item xs={4} className="d-flex align-items-center gap-2">
                  <Grid item xs={abrirPersonalizado ? 7 : 12}>
                    <Select
                      label="Tempo de Antecedência"
                      id="lembreteAntecedenciaServico"
                      name="lembreteAntecedenciaServico"
                      value={configuracao.lembreteAntecedenciaServico ?? ""}
                      onChange={onChange}
                      fullWidth
                    >
                      <MenuItem value="">Não Avisar</MenuItem>
                      <MenuItem value={15}>15 Minutos</MenuItem>
                      <MenuItem value={30}>30 Minutos</MenuItem>
                      <MenuItem value={60}>1 Hora</MenuItem>

                      {antecedenciaPersonalizada && (
                        <MenuItem value={antecedenciaPersonalizada}>
                          {formatarAntecedencia(antecedenciaPersonalizada)}
                        </MenuItem>
                      )}

                      <MenuItem
                        onClick={() => {
                          setAbrirPersonalizado(true);
                          setHoraPersonalizada(new Date(0, 0, 0, 0, 0));
                        }}
                        sx={{ fontStyle: "italic" }}
                      >
                        Personalizado
                      </MenuItem>
                    </Select>
                  </Grid>
                  {abrirPersonalizado && (
                    <Grid item xs={5}>
                      <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={ptBR}
                      >
                        <DesktopTimePicker
                          label="Antecedência"
                          value={horaPersonalizada}
                          minTime={new Date(0, 0, 0, 0, 0)}
                          maxTime={new Date(0, 0, 0, 12, 0)}
                          onChange={(newValue) => {
                            if (!newValue) return;
                            setHoraPersonalizada(newValue);
                          }}
                          onAccept={(finalValue) => {
                            if (!finalValue) return;
                            aplicarAntecedencia(finalValue);
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              onKeyDown: (e) => {
                                if (e.key === "Enter" && horaPersonalizada) {
                                  aplicarAntecedencia(horaPersonalizada);
                                }
                              },
                            },
                          }}
                          ampm={false}
                          minutesStep={5}
                          fullWidth
                        />
                      </LocalizationProvider>
                    </Grid>
                  )}
                </Grid>
                <Grid item xs={8}>
                  {`SER003 - Exibir campo "Descrição do Serviço" no cadastro de O.S`}
                </Grid>
                <Grid item xs={4}>
                  <Switch
                    id="exibirDescricaoServico"
                    name="exibirDescricaoServico"
                    checked={
                      configuracao?.exibirDescricaoServico
                        ? configuracao?.exibirDescricaoServico
                        : false
                    }
                    onChange={onChangeSwitch}
                    color="primary"
                  />
                </Grid>
                <Grid item xs={8}>
                  SER004 - Configurações da Ordem de Serviço.
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => setOpenDialogConfiguracao(true)}
                  >
                    <b>Configurar Ordem Serviço</b>
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  SER005 - Status personalizados para O.S
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => setOpenDialogStatusPersonalizados(true)}
                  >
                    <b>Configurar Status Personalizados para O.S</b>
                  </Button>
                </Grid>
                <Grid item xs={8}>
                  SER006 - Modalidade de vendedor ao adicionar itens em O.S
                </Grid>
                <Grid item xs={4}>
                  <Select
                    label="Opções"
                    id="vendedorPorItemServico"
                    name="vendedorPorItemServico"
                    value={configuracao.vendedorPorItemServico ?? ""}
                    onChange={onChange}
                    fullWidth
                  >
                    <MenuItem value={false}>Utilizar usuário de acesso como vendedor</MenuItem>
                    <MenuItem value={true}>Selecionar vendedor por item adicionado</MenuItem>
                  </Select>
                </Grid>
                {permissoesHelper.temPermisao("servicos-cadastrar") && (
                  <>
                    <CamposPersonalizadosAtivosDialog
                      open={openDialogPrecificao}
                      setOpen={setOpenDialogPrecificao}
                    />
                    <ConfiguracoesOrdemServicosDialog
                      openDialog={openDialogConfiguracao}
                      handleCloseDialog={() => setOpenDialogConfiguracao(false)}
                    />
                    <StatusPersonalizadoOsDialog
                      open={openDialogStatusPersonalizados}
                      setOpen={setOpenDialogStatusPersonalizados}
                    />
                  </>
                )}
              </>
            ) : null}
          </Grid>
        </CardContent>
      </Card>
    </>
  );
};
export default ConfiguracaoServicosTab;
